<template>
	<div class="row">
		<div class="col-md-12 overflow-auto">
			<div class="table-ui-detail" style="min-height: 300px; max-height: 420px">
				<table class="ts-w-full" style="max-height: 420px">
					<thead>
						<tr>
							<th width="5%" class="ts-text-center">
								<a-checkbox v-model="check_all" size="small" @change="onCheckAll"
									:indeterminate="indeterminate" />
							</th>
							<th width="15%">
								{{ $t('promotion.productGroup') }}
							</th>
							<th width="15%">
								{{ $t('promotion.barcode') }}
							</th>
							<th width="25%">
								{{ $t('promotion.product') }}
							</th>
							<th width="10%">
								{{ $t('promotion.discountType') }}
							</th>
							<th width="10%">
								{{ $t('promotion.discountRate') }}
							</th>
							<th width="10%">
								{{ $t('promotion.incentiveType') }}
							</th>
							<th width="10%">
								{{ $t('promotion.incentiveRate') }}
							</th>
							<th width="5%" class="ts-px-2 ts-whitespace-no-wrap ts-text-center">
								<a href="#" class="ts-text-blue-500" @click.prevent="addByChecked()">
									<i class="fa fa-plus"></i>
								</a>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-if="products.length == 0">
							<td colspan="9" class="ts-text-center ts-p-3 ts-space-x-1">
								<i class="fa fa-folder-open ts-text-gray-200"></i>
								<label class="ts-text-gray-400">
									{{ $t('noData') }}
								</label>
							</td>
						</tr>
						<tr v-if="products.length > 0" v-for="(product, index) in products" :value="product.product_id"
							:key="index" class="ts-cursor-pointer hover:ts-bg-gray-300">
							<td class="ts-text-center">
								<a-checkbox v-model="product._selected" size="small" @change="onCheckItem" />
							</td>
							<td class="ts-px-2">
								{{ product.pro_group_name_en }}
							</td>
							<td class="ts-px-2">
								{{ product.barcode }}
							</td>
							<td class="ts-px-2">
								{{ product.product_name_en }}
							</td>
							<td>
								<a-select v-model="product.discount_type" class="ts-w-full" style="min-width: 50px"
									@change="onChangeItem(product)">
									<a-select-option value="%">%</a-select-option>
									<a-select-option :value="getDiscountCurrency(product.input_currency_id)">
										{{ getDiscountCurrency(product.input_currency_id) }}
									</a-select-option>
								</a-select>
							</td>
							<td>
								<input v-if="product.discount_type == '%'" ref="discountRate" type="number"
									v-model.number="product.input_discount_rate" class="form-control"
									@change="onChangeItem(product)" />
								<ts-currency-converter-input v-else :input_amount.sync="product.input_discount_rate"
									:amount.sync="product.discount_rate"
									:input_currency_id.sync="product.input_currency_id"
									:currency_id.sync="product.currency_id" :fx_rate.sync="product.fx_rate"
									:fx_rate_ratio.sync="product.fx_rate_ratio" style="min-width: 120px;" />
							</td>
							<td>
								<a-select v-model="product.incentive_type" class="ts-w-full" style="min-width: 50px"
									@change="onChangeItem(product)">
									<a-select-option value="%">%</a-select-option>
									<a-select-option :value="getDiscountCurrency(product.input_currency_id)">
										{{ getDiscountCurrency(product.input_currency_id) }}
									</a-select-option>
								</a-select>
							</td>
							<td>
								<input v-if="product.incentive_type == '%'" ref="incentiveRate" type="number"
									v-model.number="product.input_incentive_rate" class="form-control"
									@change="onChangeItem(product)" />
								<ts-currency-converter-input v-else :input_amount.sync="product.input_incentive_rate"
									:amount.sync="product.incentive_rate"
									:input_currency_id.sync="product.input_currency_id"
									:currency_id.sync="product.currency_id" :fx_rate.sync="product.fx_rate"
									:fx_rate_ratio.sync="product.fx_rate_ratio" style="min-width: 120px;" />
							</td>
							<td class="ts-px-2 ts-whitespace-no-wrap ts-text-center">
								<a href="#" class="ts-text-blue-500" @click.prevent="addItem(product)">
									<i class="fa fa-plus"></i>
								</a>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { includes } from 'lodash';
import { mapState } from 'vuex'

export default {
	name: 'productListByItem',
	props: ['value', 'filter'],
	data() {
		return {
			check_all: false,
			indeterminate: false,
			model: {},
		}
	},
	created() {
		this.model = this.value
	},
	computed: {
		...mapState('promotion/incentiveByAmount', ['formViewDatas']),
		products() {
			if (this.formViewDatas['products']) {
				return this.formViewDatas['products']
					.filter(p => this.filter.pro_group_id ? p.pro_group_id == this.filter.pro_group_id : true)
					.filter(p => !includes(this.model.condition.map(el => el.product_id), p.product_id))
					.filter(
						p => this.filter.search
							.split(' ')
							.every(s =>
								p.barcode.toLowerCase().includes(s.toLowerCase())
							) ||
							this.filter.search
								.split(' ')
								.every(s => p.product_name_en.toLowerCase().includes(s.toLowerCase()))
					)
					.slice(0, 40)
			}
			return []
		},
	},
	methods: {
		getDiscountCurrency(input_currency_id) {
			if (this.formViewDatas['currency']) {
				let currency = this.formViewDatas['currency'].find(
					el => el.currency_id == input_currency_id
				).currency_symbol

				return currency ? currency.currency_symbol : null
			}
			return null
		},
		onCheckAll(data) {
			this.indeterminate = false
			this.products.forEach(el => {
				el._selected = data.target.checked
			});
		},
		onCheckItem(data) {
			const is_false = this.products.find(el => el._selected == false)
			const is_true = this.products.find(el => el._selected == true)
			if (is_false && is_true) {
				this.indeterminate = true
			}
			if (!is_false && is_true) {
				this.check_all = true
				this.indeterminate = false
			}
			if (is_false && !is_true) {
				this.check_all = false
				this.indeterminate = false
			}
			if (this.products.length == 0) {
				this.check_all = false
				this.indeterminate = false
			}
		},
		onChangeType() {
			this.products.map(el => el._selected = false)
			this.indeterminate = false
		},
		onCheckItem(data) {
			const is_false = this.products.find(el => el._selected == false)
			const is_true = this.products.find(el => el._selected == true)
			if (is_false && is_true) {
				this.indeterminate = true
			}
			if (!is_false && is_true) {
				this.check_all = true
				this.indeterminate = false
			}
			if (is_false && !is_true) {
				this.check_all = false
				this.indeterminate = false
			}
			if (this.products.length == 0) {
				this.check_all = false
				this.indeterminate = false
			}
		},
		onChangeItem(product) {
			if (product.discount_type == '%') {
				product.discount_rate = product.input_discount_rate
			} else {
				product.discount_type = this.getDiscountCurrency(product.input_currency_id)
				product.discount_rate = product.input_discount_rate * product.fx_rate_ratio
			}

			if (product.incentive_type == '%') {
				product.incentive_rate = product.input_incentive_rate
			} else {
				product.incentive_type = this.getDiscountCurrency(product.input_currency_id)
				product.incentive_rate = product.input_incentive_rate * product.fx_rate_ratio
			}
		},
		addByChecked() {
			let products = this.products.filter(el => el._selected == true)

			if (products) {
				products.forEach(product => {
					this.model.condition.push({
						pro_group_id: product.pro_group_id,
						product_id: product.product_id,
						operator_sign: null,
						amount_from: null,
						input_amount_from: null,
						amount_to: null,
						input_amount_to: null,
						currency_id: product.currency_id,
						input_currency_id: product.input_currency_id,
						fx_rate: product.fx_rate,
						fx_rate_ratio: product.fx_rate_ratio,
						discount_type: product.discount_type,
						discount_rate: product.discount_rate,
						input_discount_rate: product.input_discount_rate,
						incentive_type: product.incentive_type,
						incentive_rate: product.incentive_rate,
						input_incentive_rate: product.input_incentive_rate,
						_selected: product._selected,
					})
				});
				this.onCheckItem()
			}
		},
		addItem(product) {
			let newItem = {
				pro_group_id: product.pro_group_id,
				product_id: product.product_id,
				operator_sign: null,
				amount_from: null,
				input_amount_from: null,
				amount_to: null,
				input_amount_to: null,
				currency_id: product.currency_id,
				input_currency_id: product.input_currency_id,
				fx_rate: product.fx_rate,
				fx_rate_ratio: product.fx_rate_ratio,
				discount_type: product.discount_type,
				discount_rate: product.discount_rate,
				input_discount_rate: product.input_discount_rate,
				incentive_type: product.incentive_type,
				incentive_rate: product.incentive_rate,
				input_incentive_rate: product.input_incentive_rate,
				_selected: product._selected,
			}
			this.model.condition.push(newItem)
			this.onCheckItem()
		},
	},
}
</script>

<style scoped>
.form-control {
	height: 30px;
}
</style>
<style>
.filter .ant-select-selection--single {
	height: 29px;
}

.ivu-checkbox-small {
	margin: 0;
}
</style>